import React from 'react';
import { useTranslation } from 'react-i18next';
import { currencyNameConverter } from '../../../utils/Currency/currencyNameConverter';
import { Link } from 'react-router-dom';

export const PlayersColumns = (activeCurrencyCode: string) => {
    const { t } = useTranslation();

    return [
        {
            title: t('externalPlayerId'),
            label: 'externalPlayerId',
            dataIndex: 'login',
            key: 'login',
            width: 185,
            fixed: true,
            sorter: true,
            render: (text: any, record: any) => (
                <Link className="login" to={record.link}>
                    {text}
                </Link>
            ),
        },
        {
            title: t('casino_report_from_date'),
            label: 'casino_report_from_date',
            dataIndex: 'fromDate',
            key: 'fromDate',
            render: (text: any) => {
                return <span>{text}</span>;
            },
            width: 165,
            fixed: true,
        },
        {
            title: t('casino_report_to_date'),
            label: 'casino_report_to_date',
            dataIndex: 'toDate',
            key: 'toDate',
            render: (text: any) => <span>{text}</span>,
            width: 165,
        },
        {
            title: t('rounds'),
            label: 'rounds',
            dataIndex: 'spins',
            key: 'spins',
            sorter: true,
            width: 165,
        },
        {
            title: t('currency_filter'),
            label: 'currency_filter',
            dataIndex: 'currencyId',
            key: 'currencyId',
            render: (text: any) =>
                text === 0 ? t('all_consolidated') : currencyNameConverter.idToCode(text),
            width: 165,
        },
        {
            title: 'Round Type',
            label: 'Round Type',
            dataIndex: 'roundType',
            key: 'roundType',
            width: 165,
            render: (value: string) => {
                const map: Record<string, string> = {
                    regular: 'Regular round',
                    'free-round': 'Free round',
                    buy: 'Buy feature',
                    'awarded-feature': 'Awarded feature ',
                };
                return map[value] || value;
            },
            sorter: (a: any, b: any) => {
                const mapOrder: Record<string, number> = {
                    regular: 1,
                    free: 2,
                    buy_feature: 3,
                    awarded_feature: 4,
                };
                return (mapOrder[a.roundType] || 99) - (mapOrder[b.roundType] || 99);
            },
        },
        {
            title: () => (
                <span className="table-title__span">
                    {t('bet')}
                    <span>{activeCurrencyCode}</span>
                </span>
            ),
            label: 'bet',
            dataIndex: 'bet',
            key: 'bet',
            sorter: true,
            width: 165,
        },
        {
            title: () => (
                <span className="table-title__span">
                    {t('win')}
                    <span>{activeCurrencyCode}</span>
                </span>
            ),
            label: 'win',
            dataIndex: 'win',
            key: 'win',
            sorter: true,
            width: 165,
        },
        {
            title: () => (
                <span className="table-title__span">
                    {t('net')}
                    <span>{activeCurrencyCode}</span>
                </span>
            ),
            label: 'net',
            dataIndex: 'net',
            key: 'net',
            width: 165,
        },
        {
            title: () => (
                <span className="table-title__span">
                    {t('rtp')}
                    <span>%</span>
                </span>
            ),
            label: 'rtp',
            dataIndex: 'rtp',
            key: 'rtp',
            width: 165,
        },
    ];
};
